<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">
                    @if (isModoPadrao) {
                    {{ isEditMode ? 'Editar Configurações de Tributos' : 'Configurações de Tributos' }}
                    } @else {
                    {{ isEditMode ? 'Editar Regra Tributária' : 'Nova Regra Tributária' }}
                    }
                </h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="cancelar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Defina a classificação e a tributação IBS/CBS/IS desta regra.
                </p>
            </div>
        </div>

        <!-- Indicador de etapas (modo convencional). Nesta fase, apenas a etapa Tributação é funcional. -->
        @if (!isModoPadrao) {
            @if (isLoading) {
            <div class="skeleton-wizard-steps">
                @for (step of [1, 2, 3, 4]; track $index) {
                <div class="wizard-step-item">
                    <div class="step-circle skeleton"></div>
                    <div class="skeleton skeleton-step-label"></div>
                </div>
                @if ($index < 3) {
                <div class="step-connector skeleton"></div>
                }
                }
            </div>
            } @else {
            <app-wizard-steps [passos]="etapas" [descricoes]="descricoesEtapas" [passoAtual]="etapaAtual" [clicavel]="true"
                (passoSelecionado)="onEtapaSelecionada($event)"></app-wizard-steps>

            }
        }

        @if (isLoading) {
        <div class="regra-skeleton">
            <div class="skeleton skeleton-line skeleton-line--title"></div>
            <div class="skeleton-grid">
                <div class="skeleton skeleton-field"></div>
                <div class="skeleton skeleton-field"></div>
                <div class="skeleton skeleton-field"></div>
                <div class="skeleton skeleton-field"></div>
            </div>
        </div>
        } @else {

        @if (isModoPadrao || etapaAtual === 0) {
        <app-regra-tributaria-tributacao-step
            [form]="form"
            [csts]="csts"
            [cclasstribs]="cclasstribs"
            [relacoes]="relacoesCstCclasstrib"
            [modelosDocumento]="modelosDocumento"
            [isModoPadrao]="isModoPadrao"
            [indicadoresUi]="indicadoresUi"
            [formulasIbsCbs]="formulasIbsCbs"
            [formulasCbs]="formulasCbs"
            [formulasIbsUf]="formulasIbsUf"
            [formulasIbsMunicipio]="formulasIbsMunicipio"
            [formulasTribRegular]="formulasTribRegular"
            [formulasMonoPadrao]="formulasMonoPadrao"
            [formulasMonoRetencao]="formulasMonoRetencao"
            [formulasMonoRetida]="formulasMonoRetida"
            [formulasMonoDiferimento]="formulasMonoDiferimento"
            [formulasCreditoPresumidoOperacao]="formulasCreditoPresumidoOperacao"
            [formulasCreditoPresumidoIbs]="formulasCreditoPresumidoIbs"
            [formulasCreditoPresumidoCbs]="formulasCreditoPresumidoCbs"
            [formulasRegra]="formulasRegra"
            [codigosCreditoPresumido]="codigosCreditoPresumido"
            [indicadoresDoacao]="indicadoresDoacao">
        </app-regra-tributaria-tributacao-step>
        }

        @if (!isModoPadrao && etapaAtual === 1) {
        <app-regra-tributaria-escopo-step
            [form]="form"
            [listaRegimeTributario]="listaRegimeTributario"
            [listaTipoTributario]="listaTipoTributario">
        </app-regra-tributaria-escopo-step>
        }

        @if (!isModoPadrao && etapaAtual === 2) {
        <app-regra-tributaria-natureza-step
            [form]="form"
            [(naturezasSelecionadas)]="naturezasSelecionadas">
        </app-regra-tributaria-natureza-step>
        }

        @if (!isModoPadrao && etapaAtual === 3) {
        <app-regra-tributaria-revisao-step
            [form]="form"
            [csts]="csts"
            [cclasstribs]="cclasstribs"
            [modelos]="modelosDocumento"
            [listaRegimeTributario]="listaRegimeTributario"
            [listaTipoTributario]="listaTipoTributario"
            [naturezasSelecionadas]="naturezasSelecionadas"
            (editarEtapa)="irParaEtapa($event)">
        </app-regra-tributaria-revisao-step>
        }

        }

    </div>
</div>

<app-footer-action
    [salvarLabel]="labelBotaoSalvar"
    [cancelarLabel]="labelBotaoCancelar"
    [isLoadingSalvar]="isSaving"
    [isSalvarDisabled]="isLoading"
    (cancelar)="onBotaoCancelar()"
    (salvar)="onBotaoSalvar()">
</app-footer-action>
